import React, { useEffect, useState } from "react";
import { Users, Pencil, Loader2, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const valueOf = (dossier, f) => (f.team_field ? dossier[f.team_field] : (dossier.equipe || {})[f.id]) || "";

export default function EquipeBlock({ dossier, onUpdated }) {
  const [editing, setEditing] = useState(false);
  const [fams, setFams] = useState([]);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/families", { params: { partner: true } }).then((r) => setFams(r.data.items || [])).catch(() => {}); }, [editing]);
  useEffect(() => { setForm(Object.fromEntries(fams.map((f) => [f.id, valueOf(dossier, f)]))); }, [dossier, fams]);
  const shown = fams;
  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/families/equipe/${dossier.id}`, { values: Object.fromEntries(shown.map((f) => [f.id, form[f.id] || null])) });
      toast.success("Équipe mise à jour");
      setEditing(false);
      onUpdated?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); }
    finally { setBusy(false); }
  };
  return (
    <div className="card-flat px-5 py-3 flex items-center gap-6 flex-wrap" data-testid="header-equipe-card">
      <div className="overline flex-shrink-0 flex items-center gap-1.5"><Users className="w-3 h-3" /> Équipe</div>
      <div className="flex-1 min-w-0 grid grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-2">
        {shown.map((f) => {
          const key = f.team_field || f.id;
          const cur = form[f.id] || "";
          return (
            <div key={f.id} className="flex flex-col min-w-0" data-testid={`equipe-${key}`}>
              <span className="text-[9px] uppercase tracking-wider text-norea-textMuted truncate">{f.name}</span>
              {editing ? (
                <select value={cur} onChange={(e) => setForm({ ...form, [f.id]: e.target.value })} className="mt-0.5 px-2 py-1 text-sm border border-norea-border rounded bg-white" data-testid={`equipe-select-${key}`}>
                  <option value="">—</option>
                  {cur && !f.names.includes(cur) && <option value={cur}>{cur} (hors annuaire)</option>}
                  {f.names.map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
              ) : (
                <span className={`text-sm font-medium truncate ${valueOf(dossier, f) ? "text-norea-text" : "text-amber-700"}`} data-testid={`equipe-value-${key}`}>{valueOf(dossier, f) || "—"}</span>
              )}
            </div>
          );
        })}
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0">
        {editing ? (
          <>
            <button onClick={save} disabled={busy} className="btn-primary text-xs" data-testid="equipe-save">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} Enregistrer</button>
            <button onClick={() => setEditing(false)} className="p-1.5 rounded hover:bg-norea-surfaceHover" data-testid="equipe-cancel"><X className="w-3.5 h-3.5" /></button>
          </>
        ) : (
          <button onClick={() => setEditing(true)} className="text-xs px-2.5 py-1 rounded border border-norea-border hover:bg-norea-surfaceHover inline-flex items-center gap-1" data-testid="equipe-edit"><Pencil className="w-3 h-3" /> Choisir</button>
        )}
      </div>
    </div>
  );
}
